import React from "react";
import CookieConsent from "react-cookie-consent";
import styles from "./CookieNotice.module.scss";

function CookieNotice() {
  return (
    <CookieConsent
      location="bottom"
      buttonText="Got it!"
      cookieName="essentialCookiesNoticeDismissed"
      expires={365}
      disableStyles={true}
      containerClasses={styles["notice-container"]}
      contentClasses={styles["notice-content"]}
      buttonClasses={styles["notice-button"]}
    >
      <strong>Quick Notice:</strong> We use essential cookies and local browser 
      storage to keep this application working properly. Because these are mandatory 
      for the core features of the tool to function, they cannot be disabled.
    </CookieConsent>
  );
}

export default CookieNotice;